<template>
  <li
    class="roomie-action-menu-option"
    :class="{ 'is-active': isSelected }"
    @click="toggleActive">
    <slot />
    <div class="roomie-action-menu-option__icon">
      <RoomieIcon custom-styles="roomie-icon w-[24px] h-[24px] text-pine-600">
        <TickLogo />
      </RoomieIcon>
    </div>
  </li>
</template>

<script>
import RoomieIcon from '../RoomieIcon/index.vue'
import TickLogo from '../../assets/icons/v2/tick.svg'

export default {
  name: 'RoomieActionMenuOption',
  components: { RoomieIcon, TickLogo },
  props: {
    itemName: {
      type: String,
      default: ''
    },
    selectedOption: {
      type: Object,
      default: () => ({})
    }
  },
  data: function () {
    return {
      isSelected: false,
    }
  },
  mounted() {
    if(this.normalizeName(this.itemName) === (this.selectedOption && this.normalizeName(this.selectedOption.name))) {
      this.isSelected = !this.isSelected
    }
  },
  methods: {
    toggleActive() {
      this.isSelected = !this.isSelected
      this.$emit('toggle-select')
    },
    normalizeName(name) {
      if (name) return name.replace(/[é]/g,'e')

      return ''
    }
  }
}
</script>

<style src="./_index.scss" lang="scss" />
